import React, { useState } from 'react';
import '../App.css';
// 1. Добавляем useSearchParams
import { useNavigate, useSearchParams } from 'react-router-dom';
import { loginWithEmail } from '../services/api';
import idbanner from '../assets/id.png';
import pointsbanner from '../assets/banner.png';

export default function Login({ isSSOMode = false, onSSOSuccess }) {
    const [view, setView] = useState('discord');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    // 2. Получаем параметры из URL
    const [searchParams] = useSearchParams();
    const redirectUrl = searchParams.get('redirect');
    const banner = !isSSOMode ? pointsbanner : idbanner;
    document.title = !isSSOMode ? "HATCHUP POINTS" : "HATCHUP ID";
    const subtitleText = !isSSOMode ? "Отслеживайте свой прогресс на сервере" : "Вход в сервисы хачапа";
    const discordClientId = process.env.REACT_APP_DISCORD_CLIENT_ID;
    const discordRedirectUri = process.env.REACT_APP_DISCORD_REDIRECT_URI;
    const encodedRedirectUri = encodeURIComponent(discordRedirectUri);
    const discordAuthUrl = `https://discord.com/api/oauth2/authorize?client_id=${discordClientId}&redirect_uri=${encodedRedirectUri}&response_type=code&scope=identify%20guilds.members.read`;


    // Вспомогательная функция для перенаправления после входа
    const performRedirect = () => {
        if (redirectUrl) {
            // Если есть redirect, возвращаем пользователя на сервис (например, Лаунчер)
            // decodeURIComponent нужен, так как URL закодирован в адресной строке
            window.location.href = decodeURIComponent(redirectUrl);
        } else {
            // Если это обычный вход, идем на главную
            navigate('/');
        }
    };
    const handleLoginSuccess = (token) => {
        if (isSSOMode) {
            // ВАЖНО: Просто передаем токен в SSORedirect. 
            // localStorage НЕ ТРОГАЕМ.
            onSSOSuccess(token);
        } else {
            localStorage.setItem('hatchup_token', token);
            if (redirectUrl) {
                window.location.href = decodeURIComponent(redirectUrl);
            } else {
                navigate('/');
            }
        }
    };

    const handleEmailLogin = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const response = await loginWithEmail({ email, password });
            handleLoginSuccess(response.data.token); // Используем общую функцию
        } catch (err) {
            setError(err.response?.data?.error || 'Ошибка входа.');
        }
    };

    const handleDiscordLogin = () => {
        if (isSSOMode) {
            // Если мы в SSO, запоминаем это перед уходом в Дискорд
            sessionStorage.setItem('sso_only_mode', 'true');
            sessionStorage.setItem('sso_return_url', window.location.href);
        } else if (redirectUrl) {
            localStorage.setItem('sso_redirect', decodeURIComponent(redirectUrl));
        }
        window.location.href = discordAuthUrl;
    };

    return (
        <div className="login-container">
            <div class="banner-container">
                <img src={banner} alt="HATCHUP ID" className="login-banner" />
            </div>
            <p className="subtitle">{subtitleText}</p>
            {view === 'discord' ? (
                <>
                    {/* Используем новый обработчик handleDiscordLogin */}
                    <button className="login-button" onClick={handleDiscordLogin}>
                        Войти через Discord
                    </button>
                    <a href="#email" className="switch-view-link" onClick={() => setView('email')}>Войти по почте</a>
                </>
            ) : (
                <>
                    <form onSubmit={handleEmailLogin} className="email-login-form">
                        <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" required />
                        <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Пароль" required />
                        <button type="submit">Войти</button>
                        {error && <p className="form-message error">{error}</p>}
                    </form>
                    <p className="subtitle">Для входа через почту сначала задайте её в настройках HATCHUP POINTS.</p>
                    <a href="#discord" className="switch-view-link" onClick={() => setView('discord')}>Войти через Discord</a>
                </>
            )}
        </div>
    );
}